import { UIActionType, UIAction } from '../../actions/uiActions';

const creatingOnboardingProcessReducer = (state = false, action: UIAction) => {
  switch (action.type) {
    case UIActionType.SET_CREATING_ONBOARDING_PROCESS:
      return !state;
    default:
      return state;
  }
};

export default creatingOnboardingProcessReducer;
